<template>
  <v-app>
    <div class="d-flex main-menu">
      <router-link class="router-input mx-4" to="/">
        <v-btn  color="#143d9d" dark>Сыпучие материалы</v-btn>
      </router-link>
      <router-link class="router-input mx-4" to="/warm">
        <v-btn color="#143d9d" dark>Теплоизоляционные материалы</v-btn>
      </router-link>
    </div>
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  data: () => ({
    //
  })
};
</script>

<style lang="scss">
  .main-menu{
    margin-left: 70px;
  }
.main_sight {
  text-transform: uppercase;
  font-size: 20px;
  margin-left: 40px;
}
</style>
